/**
 * useObstructionLayerInteractions Hook
 *
 * Click handler for the obstruction anchor symbol layer (rendered against
 * the unified `map-cluster-source` by `UnifiedAnchorSymbolLayer`). Thin
 * wrapper over the shared `useMapLayerClick` primitive — kept as a named
 * hook for symmetry with `useTaskLayerInteractions` and so the JSDoc
 * context (which layer, which artifact) lives next to the call site.
 *
 * Marker hover-cursor + popup preview are owned by the global
 * `useMapMarkerHoverPreview` hook (mounted in `MapInstance`) so all three
 * symbol layers share a single canvas-cursor writer.
 *
 * @module components/map/UnifiedAnchorSymbolLayer/hooks/useObstructionLayerInteractions
 */

import { type RefObject } from 'react';

import type { MapRef } from '@vis.gl/react-maplibre';

import { useMapLayerClick } from '@/components/map/hooks/useMapLayerClick';

import { OBSTRUCTION_LAYER_IDS } from '../styles/obstructionSymbolLayerStyles';

interface UseObstructionLayerInteractionsProps {
  mapRef: RefObject<MapRef | null>;
  isMapReady: boolean;
}

export function useObstructionLayerInteractions({
  mapRef,
  isMapReady,
}: UseObstructionLayerInteractionsProps): void {
  useMapLayerClick({
    mapRef,
    isMapReady,
    layerId: OBSTRUCTION_LAYER_IDS.SYMBOL,
    artifactKind: 'obstructions',
  });
}
